import { DELIVERABLES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/deliverables_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'deliverablesIndex',
	// Every deliverable of the project, unfiltered — the dependency graph. Separate
	// from deliverablesIndex because that one holds the user's filtered/searched view,
	// where a dependency or a dependent could be missing.
	'DELIVERABLE_DEPENDENCY_GRAPH',
	'DELIVERABLE_WORK_ORDERS',
	'PROJECT_TASKS_DELIVERABLES',
	'PROJECT_OVERVIEW_DELIVERABLES',
	// Read once after a project is created from a template, to match each template
	// deliverable to the one it produced and set its dependency.
	'PROJECT_CREATE_NEW_DELIVERABLES',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
